import { useContext, useEffect, useState } from "react";
import { IRosterCommand } from "../../../../interfaces/IRoster";
import { codigosRespuesta, IResponseApiFluent } from "../../../../interfaces/base/IResponse";
import RosterService from "../../../../services/rosterService";
import { IOpenPanel } from "../../../../interfaces/base/IPanel";
import { AuthContext } from '../../../../auth/context/auth-context';


const UseRosterCrear = (props: IOpenPanel) => {
    const initial: IRosterCommand = {
        codigo: "",
        diasLaborables: null,
        diasDescanso: null
    }

    const { access } = useContext(AuthContext);
    const [command, setCommand] = useState<IRosterCommand>(initial);
    const [disableForm, setDisableForm] = useState<boolean>(true);
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false)
    const [buttonSalir, setButtonSalir] = useState<boolean>(false)



    const postInsertarRoster = () => {
        setLoading(true)
        RosterService.crearRoster(command)
            .then((res) => {
                if (res.status == 200) {
                    setStatus(200)
                    setMensaje(res.data.mensaje);
                    setTimeout(() => {
                        props.reload?.();
                        cerrarPanel()
                    }, 3000)
                } else {
                    setStatus(500)
                }
                setLoading(false)
            })
            .catch((e) => {
                if (
                    e.response?.data &&
                    'type' in e.response.data &&
                    'title' in e.response.data &&
                    'status' in e.response.data &&
                    'instance' in e.response.data &&
                    'errors' in e.response.data
                ) {
                    const errorResponse = e.response.data as IResponseApiFluent;
                    const mensajeError = errorResponse.errors.join('\n');
                    setButtonSalir(true)
                    setMensaje(mensajeError);
                   
                } else {
                    setMensaje("Error Inesperado");
                }
                setStatus(500);
                setLoading(false);
            })
    }

    const cerrarPanel = () => {
        setMensaje("")
        setCommand(initial)
        setStatus(0)
        props.onDismiss()
    };

    /* const required: (keyof IRosterCommand)[] = [
        "codigo",
        "diasLaborables",
        "diasDescanso",
        // access?.role?.includes("Admin") ? "guardiaProgramacionId": "2"
        ...(access?.role?.includes("Admin") ? ["guardiaProgramacionId"] : [])
    ]; */

    let required: (keyof IRosterCommand)[] = [
        "codigo",
        "diasLaborables",
        "diasDescanso",
    ];

    if (!access?.role?.includes("Admin")
        && !access?.role?.includes("AreaTransporteAdmin")
        && !access?.role?.includes("AreaTransporte")) {
        required = [
            "codigo",
            "diasLaborables",
            "diasDescanso",
            "guardiaProgramacionId"
        ]
    }

    useEffect(() => {
        const check = required.every((field) => {
            const value = command[field];
            return value !== null && value !== undefined && value !== "";
        });
        setDisableForm(!check)
    }, [command])

    return { command, setCommand, postInsertarRoster, loading, setLoading, disableForm, cerrarPanel, mensaje, setMensaje, status ,buttonSalir}
}

export { UseRosterCrear }